import { WpThumbnail } from '@/types/WpRestApi'

export function getWpThumbnailUrl(
  thumbnail: WpThumbnail | []
): string | undefined {
  if (Array.isArray(thumbnail)) return
  return thumbnail.url
}
